import React from 'react';
import { User, Bot, AlertTriangle } from 'lucide-react';
import { highlightSegments } from '../../utils/placeholderHighlight';
import TranslationFeedbackControl from './TranslationFeedbackControl';

// Renders one round trip: the user's message (original + EN translation) and the bot's answer
// (EN + translation back), each with its own inline feedback control.
const TranslationTurn = ({ turn, targetLanguage, threadId }) => (
  <div className="space-y-2">
    <div className="flex justify-end">
      <div className="max-w-[80%] rounded-lg rounded-tr-sm bg-brand-blue/10 border border-brand-blue/20 px-3 py-2">
        <div className="flex items-center gap-1.5 mb-1 justify-end">
          <span className="text-xs font-bold text-ink-dim">You</span>
          <User className="h-3.5 w-3.5 text-ink-dim" />
        </div>
        <p className="text-sm">
          {highlightSegments(turn.original_query, turn.query_protected_segments, 'offsets')}
        </p>
        <div className="mt-1.5 pt-1.5 border-t border-white/10">
          <p className="text-xs text-ink-dim">
            → EN: {highlightSegments(turn.english_query, turn.query_protected_segments, 'value')}
          </p>
          {turn.to_en_agent_version && (
            <TranslationFeedbackControl
              direction="to_en"
              targetLanguage={targetLanguage}
              threadId={threadId}
              turnIndex={turn.turn_index}
              agentVersion={turn.to_en_agent_version}
              sourceText={turn.original_query}
              translatedText={turn.english_query}
            />
          )}
        </div>
      </div>
    </div>

    <div className="flex justify-start">
      <div className="max-w-[80%] rounded-lg rounded-tl-sm bg-brand-green/10 border border-brand-green/20 px-3 py-2">
        <div className="flex items-center gap-1.5 mb-1">
          <Bot className="h-3.5 w-3.5 text-brand-green" />
          <span className="text-xs font-bold text-ink-dim">Bot</span>
        </div>
        {turn.translation_failed ? (
          <>
            <p className="text-sm">{turn.english_answer}</p>
            <p className="text-xs text-warning mt-1 flex items-center gap-1">
              <AlertTriangle className="h-3 w-3" />Translation failed — showing English answer
            </p>
          </>
        ) : (
          <>
            <p className="text-sm">
              {highlightSegments(turn.translated_answer, turn.answer_protected_segments, 'value')}
            </p>
            <div className="mt-1.5 pt-1.5 border-t border-white/10">
              <p className="text-xs text-ink-dim">
                EN: {highlightSegments(turn.english_answer, turn.answer_protected_segments, 'offsets')}
              </p>
              {turn.from_en_agent_version && (
                <TranslationFeedbackControl
                  direction="from_en"
                  targetLanguage={targetLanguage}
                  threadId={threadId}
                  turnIndex={turn.turn_index}
                  agentVersion={turn.from_en_agent_version}
                  sourceText={turn.english_answer}
                  translatedText={turn.translated_answer}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

export default TranslationTurn;
